import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Shared/Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }


async saveCustomer(obj:any,isformupload:boolean) {
  return this.api.apiPostServerError(false, `External/AddCustomer`,obj,isformupload);    
}

async EditCustomer(obj:any,isformupload:boolean) {
  return this.api.apiPostServerError(false, `External/EditCustomer`,obj,isformupload);    
}

async GetLocation() {
  return await this.api.getLocation();    
}

async GetCustomerDropdownListValues(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetCustomerDropdownListValues`,obj,isformupload);    
}

async CheckDistanceforStep4(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/CheckDistanceforStep4`,obj,isformupload);    
}

async UpdateLatLongMeeting(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/UpdateLatLongMeeting`,obj,isformupload);    
}

async getcustomerdetail(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetCustomerDetail`,obj,isformupload);    
}

async getGooglecustomerdetail(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/getgooglecustomerAddressdetail`,obj,isformupload);    
}

async GetCustomerDealerDropdownListValues(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetCustomerDealerDropdownListValues`,obj,isformupload);    
}

async CustomerImageUpload(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/CustomerImageUpload`,obj,true);    
}

}
